// PurchaseTokenForm.js
import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';
import { openAndSaveInvoice } from '../utils/openAndSaveInvoice';
import axios from 'axios';
import withAuthorization from "../components/authentication";
import "react-datepicker/dist/react-datepicker.css";
import Navbar from '../components/Navbar';
const PurchaseTokenForm = () => {
  const [ownerName, setOwnerName] = useState('');
  const [ownerWhatsApp, setOwnerWhatsApp] = useState('');
  const [carTitle, setCarTitle] = useState('');
  const [carRegistrationNumber, setCarRegistrationNumber] = useState('');
  const [tokenAmount, setTokenAmount] = useState('');
  const [approxDealAmount, setApproxDealAmount] = useState('');
 const [address,setaddress]= useState('');
  const [carModel, setCarModel] = useState('');
  const [message, setMessage] = useState('');
const [submissionSuccess, setSubmissionSuccess] = useState(false);
   const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    const formData = {
      ownerName,
      ownerWhatsApp,
      carTitle,
      carRegistrationNumber,
      tokenAmount,
      approxDealAmount,
      address,
      carModel
    };
 
    
  try {
    // Send ONLY JSON. The backend reserves the invoice number, generates the PDF and returns its link.
    const response = await axios.post(`${API_BASE_URL}/purchasetoken/create`, formData, { withCredentials: true });

    // Open the invoice in a new tab and save a copy to disk
    openAndSaveInvoice(response.data);

    // Notify the user
    setSubmissionSuccess(true);

    // Optionally, reset the form
   
  } catch (error) {
    console.error('Error submitting token:', error);
    alert('Failed to submit the token application. Please try again.');
  }
  finally {
    setLoading(false); // Set loading to false after submission completes
  }
    
  };
   // State to handle any errors
   const numberToWordsIndian = (num) => {
    if (num === 0) return "ZERO"; // Explicitly handle 0 case
  
    const belowTwenty = [
      "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
  
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
  
    const placeValues = ["", "Thousand", "Lakh", "Crore"];
  
    let parts = []; // Store number parts in words
    let place = 0;  // Index to track Thousand, Lakh, Crore
  
    while (num > 0) {
      let chunk;
      if (place === 0) {
        // First chunk is three digits
        chunk = num % 1000;
        num = Math.floor(num / 1000);
      } else {
        // After first chunk, all others are two digits
        chunk = num % 100;
        num = Math.floor(num / 100);
      }
  
      if (chunk > 0) {
        const words = convertChunk(chunk, belowTwenty, tens);
        parts.unshift(words + (placeValues[place] ? " " + placeValues[place] : ""));
      }
      place++;
    }
  
    return parts.length > 0 ? parts.join(" ").trim().toUpperCase() : "ZERO";
  }
  
  function convertChunk(num, belowTwenty, tens) {
    if (num === 0) return ""; // Ensure empty chunks don't contribute
    if (num < 20) return belowTwenty[num];
    if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + belowTwenty[num % 10] : "");
    return belowTwenty[Math.floor(num / 100)] + " Hundred" + (num % 100 !== 0 ? " " + convertChunk(num % 100, belowTwenty, tens) : "");
  }

  return (
    <div><Navbar/><div className="max-w-lg mx-auto p-4 border rounded shadow-md">
    <h2 className="text-2xl font-bold mb-4"> Purchase Token Form</h2>
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative w-full p-4 border border-blue-700 rounded">
      <div className="mt-2">
        <label className="block text-sm font-semibold">Owner Name</label>
        <input
          type="text"
          value={ownerName}
          onChange={(e) => setOwnerName(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Owner WhatsApp</label>
        <input
          type="text"
          value={ownerWhatsApp}
          onChange={(e) => setOwnerWhatsApp(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Car Title</label>
        <input
          type="text"
          value={carTitle}
          onChange={(e) => setCarTitle(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Car Registration Number</label>
        <input
          type="text"
          value={carRegistrationNumber}
          onChange={(e) => setCarRegistrationNumber(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Token Amount</label>
        <input
          type="number"
          value={tokenAmount}
          onChange={(e) => setTokenAmount(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mt-2">
        <label className="block text-sm font-semibold">Token Amount <strong>in Words</strong></label>
        <input
          type="text"
          value={numberToWordsIndian(Number(tokenAmount))}
         // onChange={(e) => setApproxDealAmount(e.target.value)}
          className="w-full p-2 border rounded"
         // required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Approx Deal Amount</label>
        <input
          type="number"
          value={approxDealAmount}
          onChange={(e) => setApproxDealAmount(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mt-2">
        <label className="block text-sm font-semibold">Approx Deal Amount in <strong>in Words</strong></label>
        <input
          type="text"
          value={numberToWordsIndian(Number(approxDealAmount))}
         // onChange={(e) => setApproxDealAmount(e.target.value)}
          className="w-full p-2 border rounded"
         // required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Owner Address</label>
        <input
          type="text"
          value={address}
          onChange={(e) => setaddress(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Car Model</label>
        <input
          type="text"
          value={carModel}
          onChange={(e) => setCarModel(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      </div>

      <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600">
      {loading ? (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-50 z-50">
            {/* Spinner and Text Container */}
            <div className="flex flex-col items-center">
              {/* Outer Circle with Gradient */}
              <div className="relative w-28 h-28 mb-4">
                <div className="absolute w-full h-full border-4 border-t-transparent border-b-transparent border-l-blue-500 border-r-blue-300 rounded-full animate-spin"></div>

                {/* Inner Circle */}
                <div className="absolute top-2 left-2 w-24 h-24 bg-white rounded-full shadow-md flex items-center justify-center">
                  {/* Logo with Flip Animation */}
                  <img
                    src="https://res.cloudinary.com/dztz5ltuq/image/upload/v1731448689/apple-touch-icon_jrhfll.png" // Replace with your car logo path
                    alt="Car Logo"
                    className="w-12 h-12 animate-flip"
                  />
                </div>
              </div>

              {/* Text Below the Spinner */}
              <p className="text-xl md:text-2xl font-bold text-gray-800 text-center">
                <strong>TOKEN FORM IS SUBMITTING.... PLEASE WAIT </strong>
              </p>
            </div>
          </div>
        ) : (
          'Submit Token Form'
        )}
      </button>
      
    </form>

    {submissionSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
            <h2 className="text-xl font-semibold text-green-600">Token Form Submitted Successfully!</h2>
            <p className="mt-2 text-gray-700">THANK YOU.</p>
            <button
              onClick={() => setSubmissionSuccess(false)}
              className="mt-4 px-6 py-2 bg-blue-500 text
              white rounded-lg hover:bg-blue-600 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
  </div></div>
  );
};

export default  withAuthorization(PurchaseTokenForm, ["admin", "Employee"]);;
